import { render, staticRenderFns } from "./LaporanPenelitiKeamanan.vue?vue&type=template&id=6c01d7ac&scoped=true&"
import script from "./LaporanPenelitiKeamanan.vue?vue&type=script&lang=js&"
export * from "./LaporanPenelitiKeamanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c01d7ac",
  null
  
)

export default component.exports